// extracted by mini-css-extract-plugin
export default {"progress-title":"TitleWithProgress_progress-title__jLX+9"};